export default __webpack_public_path__ + "static/media/UnifrakturMaguntia-Regular.f178b67c.ttf";